import {useTranslation} from 'react-i18next'

export const EmptyChangelogList = () => {
  const {t} = useTranslation()
  return <div style={{margin: '3rem auto'}}>{t('changelog.nothingToShow')}</div>
}
